module.exports = __webpack_public_path__ + "a3d71a45cc181192c5a96044a0a616cd.png";